import React, { FC } from 'react'

import { Spinner } from '@knocklabs/react'

import { getRiderTeamMembersByRole } from '../../../helpers/riders'

import { IEventTeamMemberInterface } from '../../../hooks/useEventRiderTeamMembers'
import { IRegistrationByDayInterface } from '../../../models/registrations-by-day/registrationByDay.interface'

import { MEMBER_ROLES } from '../../../const/ui/ui-register.const'

interface HorseTrainerProps {
  eventTeamMembers: IEventTeamMemberInterface
  rider: IRegistrationByDayInterface
  eventTeamMembersLoading: boolean
  title?: string
}
export const HorseTrainer: FC<HorseTrainerProps> = ({
  eventTeamMembersLoading,
  eventTeamMembers,
  rider,
  title,
}) => {
  const { teamMembersNames } = getRiderTeamMembersByRole(
    eventTeamMembers,
    rider,
    MEMBER_ROLES.TRAINER
  )

  return (
    <>
      {eventTeamMembersLoading ? (
        <Spinner />
      ) : [...teamMembersNames]?.[0] ? (
        <>
          {title && `${title}  • `}
          {[...teamMembersNames].join(', ')}
        </>
      ) : (
        'No trainer'
      )}
    </>
  )
}
